export default {
  sm: `
  DATA CENTER GAK logo
  `,
};
